const {
  VALIDATION_ERRORS,
  VALIDATION_WARNINGS
} = require("../validationErrors");

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

class ErrorResolver {
  constructor() {
    this._resolvers = {};
    this._resolvers[
      VALIDATION_ERRORS.COUNTRY_CODE_NOT_ALLOWED
    ] = new NotAllowedCountryCodeResolver();
    this._resolvers[
      VALIDATION_ERRORS.INVALID_COUNTRY_CODE
    ] = new CountryCodeResolver();
    this._resolvers[
      VALIDATION_ERRORS.INVALID_PHONE_NUMBER
    ] = new InvalidPhoneResolver();
    this._resolvers[
      VALIDATION_ERRORS.DUPLICATE_CONTACT
    ] = new DuplicateResolver();
    this._resolvers[
      VALIDATION_ERRORS.OPT_OUT_NUMBER
    ] = new OptOutContactResolver();
    this._resolvers[
      VALIDATION_WARNINGS.WARNING_INVALID_FIRST_NAME_FORMAT
    ] = new InvalidFirstNameFormatResolver();
    this._resolvers[
      VALIDATION_WARNINGS.WARNING_INVALID_LAST_NAME_FORMAT
    ] = new InvalidLastNameFormatResolver();
  }

  //Resolver error and returns array of contacts that needs to be deleted
  resolve(contacts, validationError, value) {
    var resolver = this._resolvers[validationError];
    if (!resolver) throw `Resolver for ${validationError} is not registred`;
    var result = resolver.resolve(
      contacts.filter(c => c.errors.indexOf(validationError) !== -1),
      value
    );

    return result;
  }
}

class CountryCodeResolver {

  resolve(contacts,userCountryCode) {
    contacts.forEach(c => {
      c.phoneNumber.code = userCountryCode;

      var unwantedStartingDigits = new RegExp(`^(0|${userCountryCode})`);
      c.phoneNumber.number = c.phoneNumber.number?.replace(
        unwantedStartingDigits,
        ""
      );

      var i = c.errors.indexOf(VALIDATION_ERRORS.INVALID_COUNTRY_CODE);
      c.errors.splice(i, 1);
    });
    return { toBeDeleted: [], edited: contacts };
  }
}

class NotAllowedCountryCodeResolver {
  resolve(contacts) {
    return { toBeDeleted: contacts, edited: [] };
  }
}

class InvalidPhoneResolver {
  resolve(contacts) {
    return { toBeDeleted: contacts, edited: [] };
  }
}
class OptOutContactResolver {
  resolve(contacts) {
    return { toBeDeleted: contacts, edited: [] };
  }
}

class DuplicateResolver {
  resolve(contacts) {
    var toBeDeleted = [];
    contacts
      .map(x => JSON.stringify(x.phoneNumber))
      .filter(onlyUnique)
      .forEach(phoneNumber => {
        contacts
          .filter(c => JSON.stringify(c.phoneNumber) === phoneNumber)
          .forEach((c, i) => {
            if (i === 0) return;
            toBeDeleted.push(c);
          });
      });
    return { toBeDeleted: toBeDeleted, edited: [] };
  }
}

class InvalidFirstNameFormatResolver {
  resolve(contacts) {
    contacts.forEach(c => {
      c.firstName = c.firstName
        .toLowerCase()
        .replace(/(^|[^\p{L}])(\p{Ll})/gu, x => x.toUpperCase())
        .replace(/\s*[^\p{L}]\s*/gu, x => (x.trim() ? x.trim() : " "));

      var i = c.errors.indexOf(
        VALIDATION_WARNINGS.WARNING_INVALID_FIRST_NAME_FORMAT
      );
      c.errors.splice(i, 1);
    });
    return { toBeDeleted: [], edited: contacts };
  }
}

class InvalidLastNameFormatResolver {
  resolve(contacts) {
    contacts.forEach(c => {
      c.lastName = c.lastName
        .toLowerCase()
        .replace(/(^|[^\p{L}])(\p{Ll})/gu, x => x.toUpperCase())
        .replace(/\s*[^\p{L}]\s*/gu, x => (x.trim() ? x.trim() : " "));

      var i = c.errors.indexOf(
        VALIDATION_WARNINGS.WARNING_INVALID_LAST_NAME_FORMAT
      );
      c.errors.splice(i, 1);
    });
    return { toBeDeleted: [], edited: contacts };
  }
}
module.exports = {
  ErrorResolver
};
